/*
 * 戒导航 · 统一审核中心 —— 前台扩展声明
 *
 * 设计依据：doc/统一审核中心设计方案.md §5.14.9。
 *
 * 为什么必须注册（而不是"后端发了通知前端自然就会显示"）：
 *   vendor/flarum/core/js/src/forum/components/NotificationType.tsx 的渲染逻辑是
 *       const C = app.notificationComponents[notification.contentType()];
 *       return C ? <C notification={...} /> : null;
 *   取不到组件就 **静默 return null**（不报错、不显示）—— 新通知类型必须自己注册。
 *
 * 注册方式照抄官方 flarum/likes（vendor/flarum/likes/js/src/forum/extend.ts:16-17）。
 * 第一个参数是**通知类型标识**，必须与后端
 * JieDH\Review\Moderation\ModerationReceiptBlueprint::getType() 的返回值完全一致。
 */
import Extend from 'flarum/common/extenders';
import ModerationReceipt from './models/ModerationReceipt';
import ModerationReceiptNotification from './components/ModerationReceiptNotification';
export default [
/*
 * ★ 注册「处置回执」前端模型（type = moderationReceipts）。
 *
 * 为什么必须注册（漏了它 → 通知面板一片空白）：
 *   通知 API 的 relationships.subject 指向 moderationReceipts 资源，而 Flarum 前端的
 *   app.store 只接收**已注册的 type**（common/Store.ts → pushObject 对未注册 type
 *   return null 并异步抛错）。未注册时该资源进不了 store ⇒
 *   notification.subject()（common/Model.ts → hasOne）拿到 undefined ⇒
 *   forum/components/NotificationList.js:82 `if (typeof subject === 'undefined') return;`
 *   直接把整条通知丢掉 —— 于是下拉面板只剩标题和全选/清空图标，看不到任何回执内容。
 *
 * 注册 API 见 vendor/flarum/core/js/src/common/extenders/Store.ts。
 * 第一个参数必须与后端 ModerationReceiptResource::type() 的返回值完全一致。
 */
new Extend.Store().add('moderationReceipts', ModerationReceipt),
// 处置回执通知（隐藏 / 删除 / 打回待审 / 忽略标记 / 警告）
new Extend.Notification().add('jiedhModerationReceipt', ModerationReceiptNotification)];